import React from 'react';
import { Redirect } from 'react-router-dom';

export default function Main() {
  return <Redirect to="/reservation" />;
}
